import { io } from "socket.io-client";

let socket = null;

export const connectSocket = (token) => {
  socket = io(`${process.env.VUE_APP_APP_URL}`, {
    auth: {
      token // JWT
    },
    transports: ["websocket"]
  });

  socket.on("connect", () => {
    console.log("socket connected:", socket.id);
  });

  socket.on("disconnect", () => {
    console.log("socket disconnected");
  });

  return socket;
};

export const getSocket = () => socket;
